import api from '@pray/shared/utils/api';

export async function getConversation({ artistId, conversationId, cursor = null, limit = 50 } = {}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!conversationId) throw Error('Conversation ID is required');

  const params = {};
  if (cursor) params.cursor = cursor;
  if (limit) params.limit = limit;

  const url = `/web/studio/artists/${artistId}/conversations/${conversationId}`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
}
